export type AftercareFieldName =
  | 'aftercareBehavioral'
  | 'aftercareDietary'
  | 'aftercareMedical'
  | 'aftercareOther'
  | 'referralsAndFollowUpAppointments';

export type AftercareAndReferralsSectionField = {
  editorLabel?: string;
  id: string;
  key: AftercareFieldName;
  label: string;
  placeholderText: string;
};

export const AFTERCARE_AND_REFERRAL_FIELDS: AftercareAndReferralsSectionField[] =
  [
    {
      editorLabel:
        'For example, symptoms to monitor, recommended physical activity, etc.',
      id: 'behavioral',
      key: 'aftercareBehavioral' as const,
      label: 'Behavioral',
      placeholderText: 'Please describe recommendations',
    },
    {
      id: 'dietary',
      key: 'aftercareDietary' as const,
      label: 'Dietary',
      placeholderText: 'Please describe recommendations',
    },
    {
      id: 'medical',
      key: 'aftercareMedical' as const,
      label: 'Medical',
      placeholderText: 'Please describe recommendations',
    },
    {
      id: 'other',
      key: 'aftercareOther' as const,
      label: 'Other',
      placeholderText: 'Please describe recommendations',
    },
    {
      editorLabel:
        'Please document the referrals and community options provided to the patient, as well as any follow-up appointments scheduled.',
      id: 'referrals-and-follow-up-appointments',
      key: 'referralsAndFollowUpAppointments' as const,
      label: 'Referrals & follow-up appointments',
      placeholderText: 'Please enter details',
    },
  ];
